// extracted by mini-css-extract-plugin
export var footer = "_qw-0";
export var inherit = "_qw-1";
export var input = "_qw-2";
export var modalContent = "_qw-3";
export var quillEditor = "_qw-4";
export var subtitle = "_qw-5";